/**
 * Gets formatted locale
 *
 * @param {LocaleInfo} localeInfo - Locale info
 * @param {?Format} [format=lowerCase] - Format type
 * @param {?string} separator - Separator to be used
 * @return {string} - Formatted locale if the format is specified
 *
 * @example
 * // returns "en_gb"
 * getFormattedLocale()
 * getFormattedLocale('lowerCase')
 *
 * @example
 * // returns "en_GB"
 * getFormattedLocale('mixed')
 *
 * @example
 * // returns "EN_GB"
 * getFormattedLocale('upperCase')
 */
const getFormattedLocale = (localeInfo, format = 'lowerCase', separator) => {
    const { lang, country, separator: originSeparator } = localeInfo;
    const separatorToUse = separator || originSeparator;
    const localeToUse = originSeparator ? `${lang}${separatorToUse}${country}` : lang;
    switch (format) {
        case 'lowerCase':
            return localeToUse.toLowerCase();
        case 'upperCase':
            return localeToUse.toUpperCase();
        case 'mixed':
            return originSeparator
                ? `${lang.toLowerCase()}${separatorToUse}${country.toUpperCase()}`
                : lang.toLowerCase();
        default:
            return localeToUse;
    }
};
export default getFormattedLocale;
//# sourceMappingURL=getFormattedLocale.js.map